import { toSafeString } from '@shared/utils';

export const isConnectionSetupInteraction = (item) => {
  return item?.type === 'interaction' && item?.interactionType === 'connection_setup';
};

export const isDismissedConnectionPrompt = (item) => {
  const outcome = toSafeString(item?.outcome).trim().toLowerCase();
  return outcome === 'dismissed' || item?.response?.dismissed === true;
};
